import React from 'react';
import { Box } from '@mui/material';
import { ElementType, PagePartType, SidebarSectionsEnum } from 'features/document/constants';
import styles from './ContentSidebar.module.css';
import ContentBlocks from './components/ContentBlocks/ContentBlocks';
import { useAppSelector } from 'app/hooks';
import { selectSelectedItem } from 'features/document/documentSlice';
import SidebarElementFactory from './components/SidebarElementFactory/SidebarElementFactory';
import HeaderSidebar from './components/SidebarElementFactory/components/HeaderSidebar/HeaderSidebar';
import VariablesSidebar from './components/VariablesSidebar/VariablesSidebar';
import FooterSidebar from './components/SidebarElementFactory/components/FooterSidebar/FooterSidebar';
import PageSettingsSidebar from './PageSettingsSidebar/PageSettingsSidebar';

interface ContentSidebarProps {
  sidebarSection: string;
}
const ContentSidebar = ({ sidebarSection }: ContentSidebarProps) => {
  const selectedItem = useAppSelector(selectSelectedItem);
  const renderSideBar = () => {
    if (sidebarSection === SidebarSectionsEnum.Variables) {
      return <VariablesSidebar />;
    } else if (sidebarSection === SidebarSectionsEnum.TextEditor) {
      if (selectedItem?.type === PagePartType.Row) {
        //TODO: this needs a side bar editor for rows
        return null;
      }
      if (selectedItem?.type === ElementType.Header) {
        return <HeaderSidebar />;
      }
      if (selectedItem?.type === PagePartType.Page) {
        return <PageSettingsSidebar page={selectedItem.data} />;
      }
      if (selectedItem?.type === ElementType.Footer) {
        return <FooterSidebar />;
      }
      if (selectedItem?.type === PagePartType.Element) {
        return <SidebarElementFactory selectedItem={selectedItem} />;
      }
    }
    return <ContentBlocks />;
  };

  return (
    <Box className={styles.contentSidebarCanva}>
      <Box className={styles.contentSidebarCardsContainer}>{renderSideBar()}</Box>
    </Box>
  );
};

export default ContentSidebar;
